
import './App.css';

import HomePage from './Routes/HomePage';
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import VerifyotpPage from './Routes/VerifyotpPage';
import SubscriptionInProcess from './Routes/SubscriptionInProcess';
import HeFlowPage from './Routes/HeFlowPage';
import HeFlowConfirmPage from './Routes/HeFlowConfirmPage';
import SuccessPage from './Routes/SuccessPage';
import FailurePage from './Routes/FailurePage';
import { LanguageProvider} from './Routes/LanguageContext';
import HeSuccess from './Routes/HeSuccess';
import HeConfirmPage from './Routes/HeConfirmPage';

function App() {
  return (
   <Router>
     <LanguageProvider> 
      <Routes>
        <Route path='/' element= {<Navigate to="/he" />}/>
        <Route path='/home' element={<HomePage/>}/>
        <Route path='/verifyotp' element= {<VerifyotpPage/>}/>
        <Route path='/subinprocess' element={<SubscriptionInProcess/>}/>
         {/* <Route path='/he' element= {<HeFlowPage/>}/> */}
         {/* <Route path='/confirm' element= {<HeFlowConfirmPage/>}/> */}
         <Route path='/he/subscribe' element= {<SuccessPage/>}/>
         <Route path='/he/success' element={<HeSuccess />} />
         <Route path='/he/fail' element= {<FailurePage/>}/>
         <Route path='/he/confirm' element={<HeConfirmPage />} />
      </Routes>
       </LanguageProvider> 
    </Router>

  );
}

export default App;
